const messages = {
  pt: {
    translations: {
      headings: {
        dashboard: "Dashboard",
        forecast: {
          title: "Forecast",
          downloads: "Downloads",
          analysis: "Análise",
        },
        automations: "Automações",
        settings: "Configurações",
      },
      sideBar: {
        editAvatarHeading: "Editar sua foto",
        addAvatar: "Adicionar foto",
        deleteAvatar: "Excluir foto",
      },
      languageSelector: "Idioma",
      company: "Empresa",
      login: {
        title: "Acesse nossa plataforma",
        emailLabel: "Seu e-mail",
        emailPlaceholder: "exemplo@empresa.com.br",
        passwordLabel: "Sua senha",
        passwordPlaceholder: "minhasenha",
        signIn: "Entrar",
        error: "Usuário e/ou senha inválidos!",
      },
      settings: "Configurações",
      loadingSupplyDetails: "Carregando detalhes de abastecimento...",
      myAccount: "Conta",
      ranking: "Ranking",

      users: "Usuários",
      moreInformationSoon: "Em breve mais informações",
      chooseFile: "Escolher arquivo",
      passRequirements: "Por favor, insira a nova senha de acordo com os requisitos:",
      oneLetterUpperCase: "Uma letra maiúscula (A-Z)",
      oneLetterLowerCase: "Uma letra minúscula (a-z)",
      openOrders: "Pedidos em Aberto",
      oneNumber: "Um número (0-9)",
      specialCharacter: "Um caractere especial (!@#$)",
      atLeast6Characters: "Pelo menos 6 caracteres",
      conflictingOperationMessage: "Você não pode remover e atualizar o mesmo produto ao mesmo tempo",
      organization: "Organização",
      logout: "Sair",
      profilePicture: "Foto do perfil",
      loadingStoresRec: "Carregando recomendações de compra...",
      chosePicture: "Escolher foto",
      email: 'email',
      lastRegisteredUsers: "Últimos usuários cadastrados",
      loadingStores: "Carregando lojas...",
      loadingOrdersByStores: "Recuperando pedidos da loja...",
      loadingOrderItens: 'Carregando detalhes do pedido...',
      registeredOn: 'Cadastrado',
      permissions: "Permissões",
      difSumMonths: "Diferença em relação à soma de todos os meses",
      planAdjustment: "Ajuste de Plano",
      user: "Usuário",
      role: "Papel",
      stores: "Lojas",
      productHierarchy: "Hierarquia de produtos",
      numberOfLevels: "Quantidade de níveis",
      usersManagement: "Usuários",
      level: "Nível",
      levelName: "Nome do nível",
      channelRegistration: "Cadastro de canais",
      // FORECAST SECTION:
      year: "Ano",
      orderDateSent: "Data de Envio",
      month: "Mês",
      productSubgroups: "Subgrupos de cada produto",
      vendorList: "Lista de fornecedores",
      exclude: "Remover",
      weeks: "Semanas",
      months: "Meses",
      filterBy: "Filtrar por",
      generatedOn: "Predição gerada em",
      buyer: "Comprador(a)",
      suggested: "Sugerida",
      purchase: "Compra",
      shortTerm: "Curto prazo",
      longTerm: "Longo prazo",
      riskSalesLost: "em Risco de Vendas Perdidas",
      riskSalesLostColumn: "Risco de Perda de Vendas",
      capitalTiedUp: "Capital Parado",
      percentageOfShortage: "% da Falta",
      inventoryQualityIndex: "Índice de Qualidade de Estoque",
      quantityShort: "Qtd em Falta",
      planAdjustmentOpp: "em Oportunidades de Ajuste de Plano",
      generationDate: "Data de geração",
      forecastDate: "Data do forecast",
      commercialWeek: "Semana comercial",
      commercialWeeks: "Semanas comerciais",
      suggestedActions: "Ações Sugeridas",
      monthlyForecast: "Forecast mensal",
      showFilter: "Filtros",
      hideFilter: "Ocultar filtros",
      removeFilters: "Remover filtros",
      products: "Produtos",
      product: "Produto",
      fileError: "O arquivo selecionado está indisponível. Selecione datas diferentes",
      summary: "Resumo do download",
      singleFile: "Arquivo único (.xlsx)",
      singleFileCaption: "Uma aba por semana",
      multipleFiles: "Arquivos separados (.zip)",
      multipleFilesCaption: "Um arquivo por semana",
      reference: "Referência",
      exportMultiple: "Exportar vários",
      advancedExport: "Exportação avançada",
      segment: "Segmento",
      forecasts: "Forecasts",
      selectCommWeek: "Forecasts gerados nas seguintes semanas comerciais:",
      next: "Próximo",
      changeWeekModal: {
        body: "Se você alterar as semanas comerciais selecionadas, os filtros de produto aplicados serão resetados.",
      },
      attention: "Atenção!",
      sessionMessage: "Sua sessão está prestes a expirar. Deseja continuar?",
      options: "Opções",
      addPrefixOfMeasureLabel: "Adicionar Prefixo de Medida",
      downloadSummary: "Resumo do download",
      maxTenCharacters: "Máximo de 10 caracteres",
      max255Characters: "255 caracteres",
      productPurchaseRecommendation: 'Recomendação de compra do produto',
      addAnotherMale: "Adicionar outro",
      addAnotherFemale: "Adicionar outra",
      addPrefixOfMeasure: "Adicionar unidade de medida",
      addPeriod: "Adicionar período",
      unitTitle: "(Unidade)",
      commercialCalendar: "Calendário Comercial",
      insertYear: "Insira um ano entre 1000 e 9999",
      sort: "Ordenar",
      graphicHeading: "Análise Gráfica",
      descriptiveHeading: "Análise Descritiva",
      classicHeading: "Análise Clássica",
      productFilter: "Filtrar por produto",
      griffe: "Griffe",
      grife: "Grife",
      dataProcessing: "Processando seus dados",
      line: "Linha",
      group: "Grupo",
      subgroup: "Subgrupo",
      brand: "Marca",
      salesRepresentative: "Representante",
      collection: "Coleção",
      linha: "Linha",
      grupo: "Grupo",
      subgrupo: "Subgrupo",
      subgrupos: "Subgrupos",
      graphType: "Estilo de gráfico",
      lines: "Linhas",
      columns: "Colunas",
      showing: "Mostrando",
      storeProducts: "Produtos da loja",
      estimated: "Previsto",
      realized: "Realizado",
      percentDiff: "Dif %",
      diff: "Diferença %",
      stockUnits: 'Unidades em estoque',
      wape: "WAPE",
      realizado: "Realizado",
      selectOneOption: "Selecione uma opção",
      selectAtLeastOne: "Selecione ao menos uma opção",
      sortBy: "Ordenar por",
      highest: "Maior",
      lowest: "Menor",
      unitsSold: "Venda em peças",
      // Página "Análise Descritiva"
      aidronView: "Visualização Aidron",
      classicView: "Visualização Clássica",
      resultsSubtitle: "Previsão de demanda (em peças)",
      quantityStore: "Qtd em Loja",
      quantityStoreDescription: "Quantidade em estoque disponível na loja",
      week: "Semana",
      quantityShortDescription: "Quantidade em falta no estoque para atender a demanda prevista",
      all: "Todos",
      choseProducts: "Escolher produtos",
      quantityCD: "Qtd no CD",
      quantityCDDescription: "Quantidade média de estoque no centro de distribuição",
      checkAll: "Marcar todos",
      uncheckAll: "Desmarcar todos",
      analyseGraph: "Analisar gráfico",
      analyse: "Analisar",
      close: "Fechar",
      estActDif: "Prev  |  Real  |  Dif%",
      centerMonth: "Centralizar mês",
      centerWeek: "Centralizar semana",
      expand: "Expandir dados",
      shrink: "Reduzir dados",
      selectedProducts: "Produtos selecionados",
      // Página "Visualização Clássica"
      hideColumns: "Ocultar colunas",
      unhideColumns: "Reexibir colunas",
      filterByDate: "Filtrar por data",
      filterByName: "Filtrar por nome",
      searchLabel: "Buscar produto...",
      searchByProduct: "Buscar produto",
      searchError: "Sua busca não retornou resultados.",
      exportData: "Exportar dados",
      aidronForecast: "ForecastAidron",
      changeCommWeek: "Alterar semana comercial",
      editEstimated: "Editar previsão",
      finishRevision: "Finalizar revisão",
      revision: "Revisão",
      revised: "revised",
      send: "Enviar",
      reviewAndSend: "Revisar e enviar",
      typeYear: "Digite o ano...",
      forecastPeriod: "Período de predição",
      showHistory: "Exibir histórico",
      analyseAndIntegratePredictions: "Analisar e integrar as predições",
      analysePredictions: "Analisar as predições",
      recentPredictions: "Carregando previsões recentes",
      saveRevision: "Salvar revisão",
      closeRevision: "Fechar revisão",
      cancel: "Cancelar",
      dontSave: "Descartar alterações",
      forecastRevision: "Revisão de predições",
      unsavedChangesModal: {
        heading: "Salvar alterações?",
        body: "Existem alterações não salvas. Deseja salvar antes de continuar?",
        promptBody: "Existem alterações não salvas. Tem certeza que deseja sair?",
      },
      dataSent: "Dados enviados com sucesso!",
      sent: "Enviado",
      submittedOn: "Enviado em",
      sendingPreviewModal: {
        heading: "Resumo do envio",
        alreadySentProducst:
          "Você selecionou itens que já foram enviados anteriormente, portanto estes foram retirados da lista abaixo.",
        body: "Revise os dados a serem enviados. Para editar, volte à página anterior.",
      },
      noSendingIntegrationModal: {
        heading: "Não há integração com seu sistema de planejamento!",
        body: "Você não possui integração com seu sistema de planejamento configurada. Geramos um novo arquivo de exportação para você com esta versão do Forecast.",
        downloadFile: "Baixar arquivo",
      },
      back: "Voltar",
      formerWeekModal: {
        heading: "Confirme a semana comercial",
        bodyEditing: "Você está analisando as predições geradas na semana ",
        bodySending: "As predições que você está prestes a enviar para o seu sistema foram geradas na semana ",
        body2: " de ",
        body3: ". Esta não é a predição mais recente.",
        question: "Como deseja continuar?",
        stay: "Continuar na semana ",
        goToCurrent: "Ir para a semana mais recente",
      },
      savedUnsent: "Salvo e não enviado",
      salesByColor: "Venda por cor",
      salesBySizeGrid: "Venda por grade",
      seeSendingStatus: "Ver status envio",
      projectedSalesProduct: "Venda projetada do produto",
      projectedSalesNext7Days: "Venda projetada nos próximos 7 dias",
      projectedSalesNext14Days: "Venda projetada nos próximos 14 dias",
      projectedSalesNext21Days: "Venda projetada nos próximos 21 dias",
      sendingStatus: "Status de envio",
      suggestedPurchaseQty: "Valor de compra sugerida do produto",
      of: "de",
      productsAmount: "Nº de produtos",
      seeDetails: "Ver detalhes",
      hideDetails: "Ocultar detalhes",
      noCheckedProductsModal: {
        heading: "Nenhum produto selecionado!",
        body: "Para continuar, selecione um ou mais produtos da tabela.",
      },
      productRegistration: "Cadastro de produtos",
      remove: "Remover",
      hideProducts: "Ocultar produtos",
      showRegisteredProducts: "Ver produtos cadastrados",
      saveModifications: "Salvar alterações",
      errorModal: {
        heading: "Algo deu errado",
        checkFields: "Corrija os campos destacados e tente novamente.",
        changesNotSaved: "Não foi possível salvar suas alterações. Contate o administrador do sistema.",
      },
      typeValidName: "Insira um nome válido",
      savedModal: "As alterações foram salvas!",
      season: "Estação",
      seasonsRegistration: "Cadastro de estações",
      hideSeasons: "Ocultar estações",
      showRegisteredSeasons: "Ver estações cadastradas",
      and: "e",
      filterBySeason: "Filtrar por estação",
      predictions: "Predições",
      showSeasons: "Exibir estações",
      error500HTTPMessage: "Não conseguimos completar sua solicitação agora. Aguarde alguns segundos e tente de novo. Se o problema continuar, entre em contato com o suporte.",
      error409HTTPMessageHistoryPage: "Esse pedido não pode ser alterado porque já foi concluído ou cancelado.",
      error409HTTPMessageSingular: "Este produto não pode ser alterado pois já consta em uma ordem de pedido.",
      error409HTTPMessagePlural: "Estes produtos não podem ser alterados pois já constam em uma ordem de pedido.",
      error404HTTPMessage: "Não encontramos o que você estava procurando. Volte para a página anterior",
      error400HTTPMessage: "Algumas informações estão incorretas ou incompletas. Revise o que foi preenchido e tente novamente.",
      bulkImport: "Importar em lote",
      checkInformation: "Verifique as informações",
      seasonsBulkImport: "Importar estações em lote",
      step: "Passo",
      importModal: {
        step1Instruction: "Baixe o template a ser preenchido conforme o exemplo nele contido.",
        step2Instruction: "Faça upload do template preenchido com os dados que você deseja cadastrar.",
        step3Instruction: "Verifique os dados a serem importados e confirme a importação.",
        error:
          "Houve um problema na importação dos dados. Verifique os dados contidos no arquivo e, se o problema persistir, contate o administrador do sistema.",
      },
      choseFile: "Escolher arquivo",
      fileUploaded: "Arquivo carregado!",
      confirm: "Confirmar",
      seasonNumber: "Número da estação",
      seasonNumbers: "Números das estações",
      actionNotAllowed: "Ação não permitida",
      seasonName: "Nome da estação",
      seasonNames: "Nomes das estações",
      seasonMonths: "Meses das estações",
      importSeasons: "Importar estações",
      importProducts: "Importar produtos",
      percentDifference: "Diferença percentual",
      productNumber: "Número do produto",
      example: "Exemplo",
      optional: "Opcional",
      consultOnSeasonsSheet: 'Consultar número na aba "Números das estações" deste arquivo',
      new: "Novo",
      seasons: "Estações",
      wereSaved: "foram salvos(as)",
      category: "Categoria",
      wereNotSaved: "NÃO foram salvos(as)",
      wholesale: "Atacado",
      verifyData: "Verifique os dados inseridos e tente novamente. Se o problema persistir, contate o administrador do sistema.",
      simulateActions: "Simular ações",
      simulateActionsSubtitle: "Simule diversos cenários futuros em tempo real",
      exploreScenarios: "explore cenários internos e externos",
      actionsCheckout: "Checkout de Ações",
      actionsCheckoutSubtitle: "Ações marcadas para ajuste",
      salesOpportunities: "Oportunidades de Vendas",
      daily: "Diária",
      productSalesAverage: "Venda média diária do produto",
      sales: "Venda",
      buyOptimization: "Otimização de Compra",
      storesOpportunities: "Oportunidades de Lojas",
      comingSoon: "Em breve",
      opportunity: "Oportunidade",
      opportunities: "Oportunidades",
      opportunitiesAnalysis: "Análise de oportunidades",
      inCheckout: "Em Checkout",
      stockOrSalesIncreaseOptimization: "Otimização de estoque ou aumento de vendas",
      totalOpportunities: "Total de Oportunidades",
      costReduction: "redução de custo",
      channels: "Canais",
      channel: "Canal",
      adjustingPlanAndStock: "ajustando plano e estoque",
      belowForecast: "abaixo do Forecast",
      purchaseAdjustment: "Ajustes de Compra",
      assortmentAdjustment: "Ajuste de sortimento",
      assortmentOptimization: "Otimização do Sortimento",
      assortmentOpportunitities: "Oportunidade do Otimização",
      channelReplenishment: "Abastecimento dos Canais",
      replenishment: "Qualidade de Estoque",
      additionalSale: "Venda Adicional",
      addingStockAndSales: "somando estoque e vendas",
      above: "acima",
      below: "abaixo",
      productPlan: "Plano de produto",
      piecesOfClothingAbbreviation: "pçs",
      theForecast: "do Forecast",
      paretoAnalysis: "Análise de Pareto",
      loadingData: "Carregando dados...",
      ofTheTotal: "do total",
      eightyPercentOfGap: "produtos somam 80% do gap",
      channelsTarget: "Meta dos canais",
      waitingForData: "Aguardando dados",
      currentPlanVsForecast: "Plano atual x Forecast",
      monthsSumDifference: "Diferença em relação à soma de todos os meses",
      productOpportunities: "Oportunidades de Produto",
      channelOpportunities: "Oportunidades de Canais",
      marketInsights: "Insights de Mercado",
      analysis: "Análise",
      productPlanVsForecast: "Produto: Plano x Forecast",
      storesPlanVsForecast: "Lojas: Plano x Forecast",
      channelsTargetVsForecast: "Canais: Meta x Forecast",
      forecastAccuracy: "Assertividade do Forecast",
      actions: "Ações",
      adjustProductPlan: "Ajustar Plano de Produto",
      adjustmentPageTitle: "Produto | Qualidade de Estoque",
      avoidSalesLoss: "Evitar Perda de Venda",
      lossByStore: "Perda Por Loja",
      lossByStoreRankingTitle: "Ranking de Perda por Loja",
      lossByStoreRankingSubtitle: "Top 10 lojas com maior valor em falta para a família {{family}}.",
      lossByStoreRankColumn: "#",
      lossByStoreStoreColumn: "Loja",
      lossByStoreRiskColumn: "Risco de Perda",
      lossByStoreEmptyRanking: "Não há dados de perda por loja para esta família.",
      storeLabel: "Loja {{storeId}}",
      analyzeSizeCurve: "Analisar a Grade",
      optimizePurchase: "Otimizar a Compra",
      highestValue: "maior valor",
      lowestValue: "menor valor",
      showAllOpportunities: "Exibir todas as oportunidades",
      opportunityType: "Tipo de Oportunidade",
      orderBy: "Ordenar por",
      done: "Concluído",
      additionalSaleExplanation:
        "Esta oportunidade é mapeada sempre que o seu plano de vendas futuro esta abaixo do centro da demanda do cliente (a demanda do cliente por este produto pode ser observada em verde no gráfico).",
      expectedIncreaseInSales: "Aumento Esperado da Venda",
      avoidSalesLossExplanation:
        "Esta oportunidade é identificada sempre que as vendas dos últimos meses estiverem abaixo ou próximo do limite mínimo da demanda do cliente.",
      optimizePurchaseExplanation:
        "Esta oportunidade é mapeada sempre que o seu plano de vendas futuro está acima do limite máximo da demanda por este produto. No gráfico, este limite da demanda pode ser observado em verde.",
      futurePurchaseReduction: "Redução da Compra Futura",
      successTitle: "Atualização concluída com sucesso!",
      successMessage: "Os seguintes produtos foram atualizados:",
      prefixesUpdateSuccessMessage: 'Prefixos atualizados!',
      active: "Ativo",
      effectivePurchase: "Compra Final",
      reactivated: "Reativado",
      purchaseOrderHistory: "Histórico de Pedidos de Compras",
      ordersHystory: "Histórico de Pedidos",
      region: "Região",
      purchaseParam: "Parâmetros de Compra",
      purchaseQualityMenu: "Qualidade de Compra",
      regional: "Regional",
      checkout: "Checkout",
      openPurchaseOrders: "Pedidos de Compras em Aberto",
      selectAction: "Selecionar",
      productPurchaseUnit: 'Unidade de compra do produto',
      choseRegionAndStore: "Selecione região e loja",
      submitOrder: "Gerar pedido",
      unitsOfMeasure: "Unidades de Medida",
      productUnitOfMeasure: 'Unidade de medida do produto',
      confirmSupplier: "Confirme o fornecedor",
      percent: "Percentual",
      opportunitySize: "Tamanho da Oportunidade",
      code: "Sigla",
      description: "Descrição",
      status: "Status",
      deletion: "Exclusão",
      reopen: "Reabrir",
      wishReopenOpportunity: "Deseja reabrir a oportunidade?",
      opportunityWillBeAnalysed: "Oportunidade será analisada",
      opportunityWillCheckout: 'Ao selecionar esta opção, a oportunidade receberá o status "Checkout".',
      opportunityHasGoneCheckout: "A oportunidade foi enviada para Checkout de Ações!",
      notAnOpportunity: "Não é uma oportunidade",
      describeDeletionReason:
        "Ao selecionar esta opção, você poderá descrever o motivo da exclusão, e a oportunidade será removida da lista de oportunidades.",
      opportunityHasBeenRemoved: "A oportunidade foi removida.",
      removeFromCheckout: "Retirar do Checkout",
      opportunityWillRemainInList:
        'Ao selecionar esta opção, a oportunidade permanecerá na lista de oportunidades com o status "Ativo".',
      opportunityHasLeftCheckout: "A oportunidade foi retirada da lista de Checkout.",
      finalizeOpportunityOption: "Finalizar a Oportunidade",
      finalizeOpportunityOptionText: "Ao selecionar esta opção, você poderá descrever as ações que realizou para descrever que atuou nesta Oportunidade e que agora ela pode ser finalizada.",
      opportunityHasBeenFinished: "A oportunidade foi finalizada com sucesso!",
      describeExecutedActions: "Descreva brevemente as Ações executadas",
      errorContactAdmin: "Ocorreu um erro. Por favor, tente novamente ou contate o administrador do sistema",
      finish: "Finalizar",
      describeReason: "Descreva brevemente o motivo",
      remainingCharacters: "Caracteres restantes",
      transforInAction: "Transformar em ação",
      removeOpportunity: "Descartar Oportunidade",
      save: "Salvar",
      productHasOtherOpportunity: "Este produto possui outra oportunidade",
      productHasOtherOpportunities: "Este produto possui outras oportunidades",
      analyseOpportunity: "Analisar Oportunidade",
      analyseOpportunities: "Analisar Oportunidades",
      actionRecommendation: "Recomendação de ação",
      advancedAnalysis: "Análise Avançada",
      currentPlan: "Plano Atual",
      futurePlan: "Plano Futuro",
      opportunityChartError:
        "Ocorreu um erro ao carregar o gráfico desta oportunidade. Por favor, contate o administrador do sistema.",
      willBeListedAsOpportunity: "Ela voltará a ser listada como Oportunidade e seu valor contará no total ativo.",
      removedOpportunities: "Oportunidades Excluídas",
      opportunityWasReopened: "A oportunidade foi reaberta.",
      noRemovedOpportunities: "Não há oportunidades excluídas.",
      period: "Período",
      opportunityTypeTitle: "Oportunidade de {{opportunityTitle}}",
      help: "Ajuda",
      planVsForecastSubtitle:
        "Análise das principais divergências entre o Plano oficial da empresa X Forecast gerado pela Aidron",
      planVsForecastAnalysis: "Análise do Plano Atual x Forecast",
      details: "Detalhes",
      mainGrouping: "Agrupamento Principal",
      salesImpact: "Impacto na Venda",
      factorsThatImpactSales: "Fatores que Impactam a Venda",
      groupingTitle: "agrupamento {{groupingName}}",
      planVsForecast: "Plano x Forecast",
      adjustmentsRecommendations: "Recomendações de Ajustes",
      monthlyBreakdown: "Detalhamento mensal",
      customerAdoption: "Adesão de clientes",
      revenue: "Faturamento",
      storeDetails: "Detalhamento das Lojas",
      inventoryDetails: "Detalhamento do estoque",
      aiForecast: "Forecast IA",
      greatPerformance: "Ótima performance",
      otbPageTitle: "Produto | Ajustes no OTB",
      analysisBasedMessage: "Análise baseada na similaridade dos produtos",
      performance: "Desempenho",
      performanceByProduct: "Performance por Produto",
      performanceFuture: "Performance Futura",
      industryProductMix: "Sortimento Indústria",
      rovitexMatrix: "Matriz Rovitex",
      collectionOverview: "Balanço das Coleções",
      retrievingData: "Recuperando dados do seu plano...",
      ofAboveThanDemandProducts: "dos produtos com venda acima da demanda",
      criticalPoints: "Pontos de atenção",
      ofBelowThanDemandProducts: "dos produtos com venda abaixo da demanda",
      languagePortuguese: "Português",
      langaugeEnglish: "Inglês (EUA)",
      productDriversListingAndPercent: "Abaixo, a relação dos fatores que impactam na venda e o percentual de impacto de cada um",
      upcomingFeature: "Esta funcionalidade estará disponivel em breve.",
      mainGroupingBreakdown: "Quebra do Agrupamento Principal",
      total: "Total",
      analyzeProducts: "Analisar produtos",
      accuracyAnalysis: "Análise de Assertividade",
      activeOpportunities: "Oportunidades Ativas",
      possibleUpcomingFeature: "Em breve esta funcionalidade pode estar disponível para sua empresa.",
      productDrivers: "Fatores que impactam a venda deste produto",
      productDriversExplanation:
        "Esta análise identifica % de impacto de cada fator na venda deste produto. Ela é importante para dignóstico e proposição de ações que possam otimizar estoque e/ou aumentar as vendas.",
      realizedDeviationVsDemand: "Desvio Executado x Demanda",
      realizedDeviationVsDemandDescription:
        "Média percentual dos desvios do realizado em relação à demanda do cliente nos últimos dois meses. Quanto maior for este indicador, menos previsível é este item e isso pode indicar problemas de operação que precisamos resolver para tornar nosso plano mais assertivo.",
      lastMonthSaleVariation: "Variação da venda no último mês",
      lastMonthSaleVariationDescription:
        "Variação percentual entre a venda realizada no penúltimo e último mês. Quando um pico de variação ocorre (e não se trate de uma data especial que ocorreu entre um mês e outro) isso pode nos indicar um cenário de mudança repentina não prevista.",
      saleAnomalyProbability: "Probabilidade de problema na venda",
      saleAnomalyProbabilityDescription:
        "Este valor indica a probabilidade que a IA encontrou da venda histórica ter algum problema de operação, ou seja, se este índice for alto, isso indica que a variação da venda no último mês não reflete apenas um comportamento da demanda dos clientes, mas sim alguma ação da operação (ex.: mudança de preço, estratégia de sortimento, etc).",
      aiAccuracyOverClient: "Diferença Acerto IA x Plano",
      aiAccuracyOverClientDescription:
        "Se o número for positivo, significa que IA acerta mais que o Plano nos últimos 6 meses. Se for zero, significa que não há diferença no total deste período. E se for negativo, isso significa que a IA acerta menos que o plano. No entanto se a assertividade for baixa e a probabilidade de problema for alta, possivelmente temos fatores de operação que não estão nas variáveis que a IA utiliza e temos de incluir para aperfeiçoar os modelos.",
      indexesToSupport: "Índices para apoio na análise",
      productView: "Visão por produto",
      forecastGeneratedIn: "Forecast gerado em",
      indicator: "Indicador",
      searchByHierarchy: "Buscar por hierarquia",
      historicalAnalyses: "Análises Históricas",
      type: "Digite",
      filterByHierarchy: "Filtrar por hierarquia",
      clearFilters: "Limpar filtros",
      analyzeProduct: "Analisar produto",
      salesHistory: "Histórico de Vendas",
      freezeColumns: "Congelar colunas",
      choseColumns: "Escolher colunas",
      "Precipitação (Quantidade de chuvas)": "Precipitação (Quantidade de chuvas)",
      "Índice Geral de Preços (IGPM)": "Índice Geral de Preços (IGPM)",
      "Índice de confecção de artigos do vestuário e acessórios": "Índice de confecção de artigos do vestuário e acessórios",
      "Índice de importação de itens de vestuário": "Índice de importação de itens de vestuário",
      Preço: "Preço",
      retail: "Varejo",
      Margem: "Margem",
      "Índice de vendas reais no varejo": "Índice de vendas reais no varejo",
      "Índice de vendas reais no varejo do vestuário": "Índice de vendas reais no varejo do vestuário",
      Temperatura: "Temperatura",
      "Brasileiros comprando itens de vestuário fora do Brasil": "Brasileiros comprando itens de vestuário fora do Brasil",
      Chuva: "Chuva",
      "Produção de artigos do vestuário e acessórios no Brasil": "Produção de artigos do vestuário e acessórios no Brasil",
      "Venda do Varejo de vestuário Brasil": "Venda do Varejo de vestuário Brasil",
      "Venda do Varejo no Brasil": "Venda do Varejo no Brasil",
      "Fluxo de Clientes (Índices do Varejo no Brasil)": "Fluxo de Clientes (Índices do Varejo no Brasil)",
      percentParticipation: "Participação %",
      purchaseMeasurementUnitParameters: "Parâmetros de Unidade de Medida para Compra",
      ai: "IA",
      differenceAidronAndClient: "Dif IA x Plano Atual",
      percentAidronVsClient: "Dif% IA x Plano Atual",
      partPercent: "Part %",
      maxPot: "Pot Máx",
      minPot: "Pot Mín",
      maxPotential: "Potencial Máximo",
      minPotential: "Potencial Mínimo",
      purchaseSuggestion: "Sugestão de Compra",
      purchaseSuggestion7: "(7d)",
      purchaseSuggestion14: "(14d)",
      purchaseSuggestion21: "(21d)",
      averageSales: "Venda Média",
      recommendedPurchase: "Compra Sugerida",
      actualPurchase: "Compra Final",
      projection: "Projeção",
      realizedSales: "Venda Realizada",
      upperLimitAbbreviation: "Lim Superior",
      upperLimit: "Limite Superior",
      lowerLimitAbbreviation: "Lim Inferior",
      lowerLimit: "Limite Inferior",
      percentDiffAIVsProjection: "Dif% IA x Projeção",
      percentDiffCurrentPlanVsProjection: "Dif% Plano Atual x Projeção",
      percentParticipationOnRealized: "Participação % no Realizado",
      percentDifferenceAIVsRealized: "Dif% IA x Realizado",
      percentDifferenceCurrentPlanVsRealized: "Dif% Plano Atual x Realizado",
      percentParticipationInRealized: "Participação % no Realizado",
      percentDifferenceAIVsStorePlan: "Dif% IA x Plano Loja",
      aiAdjustment: "Ajuste IA",
      newPlan: "Novo Plano",
      lastForecastGeneratedOn: "Último forecast gerado em",
      pageNotFound: "Página não encontrada",
      analyzeProductAccuracy: "Analisar Assertividade Produto",
      customerDemand: "Demanda do Cliente",
      stockOptimization: "Otimização de Estoque",
      opportunitiesCheckout: "Checkout de Oportunidades",
      checkoutSummary: "Resumo do Checkout",
      noOpportunitiesGoTo: "Nenhuma oportunidade foi enviada para Checkout. Para isso, vá para a",
      opportunitiesPage: "página de Oportunidades",
      opportunityWasFinalized: "Oportunidade finalizada",
      storeSalesIncrease: "Aumento de Vendas da Loja",
      store: "Loja",
      missingSuppliersInfo: "Alerta: existem produtos sem o fornecedor informado!",
      opportunityWillBeFinalized:
        "Ao clicar em Ok, esta oportunidade será finalizada e marcada como Aplicada no Planejamento atual da empresa",
      newPhotoSaved: "Sua nova foto foi salva com sucesso.",
      newPasswordSaved: "Nova senha salva com sucesso!",
      newPasswordNotSaved:
        "Sua senha NÃO pode ser salva. Tente novamente em instantes. Se o problema persistir, contate o administrador do sistema.",
      changePassword: "Alterar senha",
      newPassword: "Nova senha",
      modifyOrder: "Alterar",
      repeatNewPassword: "Repetir nova senha",
      savePassword: "Salvar senha",
      newPlanUnsavedChanges: "Pode haver alterações não salvas na edição do Novo Plano. Tem certeza que deseja sair?",
      adjustSalesPlan: "Ajustar Plano de Vendas",
      backToOriginalValue: "Retornar ao valor original",
      return: "Retornar",
      emptyResult: "Sua busca não retornou resultados.",
      clientDemandVsPlan: "Demanda do Cliente x Plano",
      salesProblemProbability: "Probabilidade de Problema na Venda",
      differenceAIAccuracyVsPlan: "Diferença Acerto IA x Plano",
      featureComingSoon: "Esta funcionalidade estará disponivel em breve.",
      differenceFromPlan: "Diferença do Plano",
      avoidedStockSurplus: "Excesso de Estoque Evitado",
      surplus: "Excesso",
      enterSearchTerm: "Insira termo de busca...",
      noItemsForCurveBreak: "Este produto não possui itens nesta quebra de curva",
      noItemsForColumn: "Este produto não possui itens para esta coluna",
      salesBreakdown: "Quebra de Curva",
      salesBreakdown_A: "Quebra de curva A",
      salesBreakdown_B: "Quebra de curva B",
      salesBreakdown_C: "Quebra de curva C",
      priceRange: "Quebra por Faixa de Preço",
      avgPrice: "Preço médio",
      priceRange_high: "Faixa de preço alta",
      priceRange_medium: "Faixa de preço média",
      priceRange_low: "Faixa de preço baixa",
      noItemsForPriceRange: "Este produto não possui itens nesta faixa de preço",
      high: "Alta",
      medium: "Média",
      low: "Baixa",
      increaseInSales: "Aumento de Vendas",
      newPlanAnalysis: "Análise do Novo Plano",
      saving: "Salvando",
      aiAdjustmentsFilter: "Filtrar Ajuste IA",
      removeFilter: "Remover filtro",
      address: "Endereço",
      filter: "Filtrar",
      currentSupplierSelected: "Fornecedor atual selecionado. Você pode alterá-lo se necessário.",
      removingItem: 'Removendo item do pedido',
      creatingOrder: "Gerando ordem de compra",
      updatingMessage: 'Atualizando dados dos produtos...',
      updateAndRemoveMessage: "Atualizando e removendo produtos...",
      updatingItems: "item sendo atualizado",
      updatingItems_plural: "itens sendo atualizados",
      registerNewUser: "Registrar Novo Usuário",
      removingItem_item: "item sendo removido",
      removingItem_plural: "itens sendo removidos",
      cancelling: "Cancelamento iniciado",
      cancellingOrder: "ordem em processo de cancelamento...",
      storePurchaseOrders: "Pedidos da Loja",
      current: "Atual",
      difference: "Diferença",
      cancelEdit: "Cancelar edição",
      orderGeneratedBy: "Pedido gerado por",
      keepEditing: "Continuar edição",
      continue: "Continuar",
      cancelOrderReturnToEdit: 'Ao cancelar, os produtos deste Pedido de Compra retornarão para a tela de Edição de Pedidos.',
      orderDate: "Data do pedido",
      supplier: "Fornecedor",
      totalSales: "Venda total",
      suppliers: "Fornecedores",
      successOnOrder: 'Pedido realizado com sucesso',
      cancelOrder: 'Cancelar',
      deleteOrder: 'Excluir',
      editWarning: "Existem alterações na tela que não foram salvas. Deseja salvá-las?",
      edit: "Editar",
      proceed: "Prosseguir",
      integrate: "Integrar",
      youMustSelectASupplier: 'Selecione um fornecedor para continuar com o pedido.',
      userActivity: "Atividade de Usuários",
      opportunityAddedToCheckout: "Oportunidade adicionada ao Checkout de Ações!",
      opportunitySuccessfullyRemoved: "Oportunidade removida com sucesso!",
      orderCancelled: 'Pedido cancelado',
      canceled: "Cancelado",
      flowDependencyForSelling: "Nível de dependência de Fluxo para Venda",
      flowDependencyForSellingExplanation:
        "Caso o percentual seja muito alto, os fatores listados acima terão pouco efeito se o fluxo de clientes não aumentar nos locais onde este produto possui uma venda alta. Para produtos com dependência de Fluxo acima de 60%, recomendamos ações na operação que tragam mais visibilidade ao produto.",
      opportunityAction: "Ação da Oportunidade",
      consolidatedView: "Visão Consolidada",
      currentInventoryView: "Visão Atual do Estoque",
      final_title: "Final",
      exportImage: 'Exportar imagem',
      finalizeAction: "Finalizar Ação",
      finalizeOrder: "Finalizar Pedido",
      finalizeOpportunity: "Finalizar Oportunidade",
      // PÁGINA: ANÁLISE DE LOJAS
      effectivePurchaseProductValue: "Valor de compra efetiva do produto",
      storesAnalytics: "Análise de Lojas",
      // PÁGINA: OPORTUNIDADES
      acronym: "Sigla",
      unitOfMeasure_title: "(un. medida)",
      showingFilteredOpportunity: "Mostrando oportunidades filtradas por produto específico",
      clearFilter: "Limpar filtro",
      noOpportunitiesFound: "Nenhuma oportunidade encontrada com os filtros aplicados",
      origin: "Origem",
      supply: "Estoque em Loja",
      leadTime: "Tempo de Entrega",
      totalQtyToBeBought: "Total que será comprado",
      leadTime_pt1: "Tempo de",
      leadTime_pt2: "Entrega",
      productLeadTimeStore: "Tempo de entrega do produto na loja",
      productLeadTime: "Tempo de entrega do produto",
      daysTitle: "(dias)",
      productMinimumQty: "Quantidade mínima do produto",
      minimumInventory_pt1: "Estoque",
      minimumInventory_pt2: "Mínimo",
      productMinimumInvetory: "Estoque ideal de produto",
      stockGroup: "Agrupamento Estoque",
      conversionFactorDescription: "Fator de conversão entre a unidade de compra e a unidade vendida pelo fornecedor",
      minimumInventory: "Estoque Ideal",
      conversionFactor: 'Conversor',
      productType: "Tipo Produto",
      commercialGroup: "Agrupamento Comercial",
      family: "Família",
      familyProduct: "Família do produto",
      higherLikehoodOfSale: "Maior probabilidade de venda",
      priority: "Relevância ($)",
      productCode: "Código",
      loadingProductDetails: "Carregando detalhes do produto...",
    },
  },
};

export { messages };
